import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Header } from 'semantic-ui-react';
import { sysAPI } from '../../../../apis/SysAPI';
import { responseError } from '../../../../helpers';
import { useDispatch } from 'react-redux';
import { StackedGraphic } from '../../Graphics/Tables';
import Loading from '../../../../components/globals/Loading';

const ActivityPeriod = forwardRef(({ activeIndex, startDate, endDate, areas, loading, excludeCompanies, includeCompanies, setLoading }, ref) => {
    const dispatch = useDispatch();
    const [labels, setLables] = useState([]);
    const [datasets, setDataset] = useState([]);
    const [internalLoading, setIntenalLoading] = useState(false)

    const getData = async () => {
        setLoading(true);
        setIntenalLoading(true);
        try {
            const { data: response_1 } = await sysAPI.get(`/advisors/graphics/weekly-processes`, {
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    isPeriod: true,
                    companies: includeCompanies.join(','),
                    excludeCompanies: excludeCompanies.join(','),
                    areas: areas.join(','),
                },
            });
            setDataset(response_1.datasets);
            setLables(response_1.labels);
        } catch (error) {
            responseError(error, undefined, 'ActivityPeriod.getData', dispatch);
        }
        setLoading(false);
        setIntenalLoading(false);
    };

    useImperativeHandle(ref, () => ({
        getData: getData,
    }));

    useEffect(() => {
        getData();

        // eslint-disable-next-line
    }, [activeIndex]);

    const options = { barPercentage: 0.3, elements: { bar: { borderWidth: 2, borderColor: 'white' } } }
    const plugins = { legend: { display: true, position: 'bottom', labels: { font: { size: 15 } } } }
    return (
        <div className='card_metrics'>
            {internalLoading ? <>
                <Loading />
            </> : <>
                <Header textAlign="center" as="h3">
                    Activity by period
                </Header>
                <div>
                    <StackedGraphic
                        labels={labels}
                        datasets={datasets}
                        options={options}
                        plugins={plugins}
                        datalabels={undefined}
                    />
                </div>
            </>}
        </div>
    );
});

export default ActivityPeriod;
